import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys as calendarKeys } from "../../calendar/api/keys";
import { keys as topicKeys } from "../../topics/api/keys";
import { keys as eventKeys } from "./keys";

async function deleteEvent(id: string) {
  const { error } = await apiClient
    .from('events')
    .delete()
    .eq('id', id)

  if (error) {
    throw error
  }
}

export function useDeleteEvent() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: async (variables: { id: string, subTopicId: string }) => deleteEvent(variables.id),
    onSuccess: (_, variables) => {
      enqueueSnackbar('Événement supprimé.', 'success');
      queryClient.invalidateQueries({ queryKey: calendarKeys.list() });
      queryClient.invalidateQueries({ queryKey: topicKeys.getHistoryFeedBySubTopicId(variables.subTopicId) });
      queryClient.invalidateQueries({ queryKey: [...topicKeys.all, 'activityTimeline'] });
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: eventKeys.upcoming(currentSpace.id) });
      }
    }
  })
}
